import { ConfigService } from "./config.service";

export function configInitializerFactory(configService: ConfigService): () => Promise<any> {
  return () => configService.loadConfigFromJson().toPromise();
}
